/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Center, Loader, rem } from '@mantine/core';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { customJson } from '@fai/third-party/react-router-dom';

import { useFlags, type BooleanFeatureFlags } from './use-flag';

export function FlagValidationWrapper({ flagKey }: { flagKey: BooleanFeatureFlags }) {
  const flags = useFlags();
  const flag = flags[flagKey];

  if (!flag) return <FlagLoading />;

  return <Outlet />;
}

FlagValidationWrapper.displayName = 'FlagValidationWrapper';

function FlagLoading() {
  const DELAY = 3000;

  const [hasError, setHasError] = useState<boolean>(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setHasError(true);
    }, DELAY);

    return () => clearTimeout(timer);
  }, []);

  if (hasError) {
    throw customJson({ message: 'This page is inaccessible.' }, { status: 403 });
  }

  return (
    <Center w="100%" h="100%" mih={rem(480)}>
      <Loader />
    </Center>
  );
}
